import { Moon, Sun } from "lucide-react";
import { Button } from "./button";
import { useTheme } from "@/context/theme-context";

export function ThemeToggle({ className }) {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    if (theme === "dark") {
      setTheme("light");
    } else {
      setTheme("dark");
    }
  };

  const isDark = theme === "dark" || 
    (theme === "system" && typeof window !== "undefined" && 
     window.matchMedia("(prefers-color-scheme: dark)").matches);

  return (
    <Button 
      variant="ghost" 
      size="icon" 
      onClick={toggleTheme}
      className={className}
      title={isDark ? "Açık temaya geç" : "Koyu temaya geç"}
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Tema değiştir</span>
    </Button>
  );
}
